module.exports = __webpack_public_path__ + "img/EU.6911808d.svg";